<app-header></app-header>
<div class="app-container">
  <!--  <app-nagivation-bar></app-nagivation-bar>-->
  <router-outlet></router-outlet>
  <footer class="footer">
    <app-footer></app-footer>
  </footer>

</div>
